
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import PoweredByAI from "@/components/PoweredByAI";
import AuraXPSection from "@/components/AURASection";
import EfficiencySection from "@/components/EfficiencySection";

import Footer from "@/components/Footer";
import AuraXPAnimation from "@/components/AURAAnimation";
import AutonomousCybercrimeSection from "@/components/AutonomousCybercrimeSection";
import SecurityChallengeBanner from "@/components/SecurityChallengeBanner";
import EmailSubscriptionBanner from "@/components/EmailSubscriptionBanner";
import OrganizationSchema from "@/components/seo/OrganizationSchema";
import CanonicalTag from "@/components/seo/CanonicalTag";
import AISecurityBanner from "@/components/AISecurityBanner";
import AgenticIntelligenceSection from "@/components/AgenticIntelligenceSection";
import PartnersSection from "@/components/PartnersSection";
import AnnouncementBanner from "@/components/AnnouncementBanner";
import HolidayEffects from "@/components/HolidayEffects";

const Index = () => {
  useEffect(() => {
    // SEO Meta updates for Spharaka Networks
    document.title = "Spharaka: The Autonomous Cyber Defence Platform Powered by Agentic AI";
    
    const metaDescription = document.querySelector('meta[name="description"]') || document.createElement('meta');
    metaDescription.setAttribute('name', 'description');
    metaDescription.setAttribute('content', 'Spharaka Networks delivers next-generation XDR powered by AuraXP to predict and stop threats before they impact your business. Industry-leading AI-powered cybersecurity solutions for enterprises, SMBs, and government organizations.');
    if (!document.querySelector('meta[name="description"]')) {
      document.head.appendChild(metaDescription);
    }

    return () => {
      try {
        if (metaDescription.parentNode) {
          document.head.removeChild(metaDescription);
        }
      } catch (e) {}
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <HolidayEffects />
      <CanonicalTag path="/" />
      <OrganizationSchema />
      <Navbar />
      <AnnouncementBanner />
      <main className="flex-1">
        <Hero />
        <AgenticIntelligenceSection />
        <AISecurityBanner />
        <AutonomousCybercrimeSection />
        {/* <AuraXPAnimation /> */}
        <PoweredByAI />
        <AuraXPSection />
        <EfficiencySection />
        <SecurityChallengeBanner />
        <PartnersSection />
        
      </main>
      <EmailSubscriptionBanner />
      <Footer />
    </div>
  );
};

export default Index;
